import { makeStyles } from '@mui/styles';
// colors
import { colors } from '../../../../../colors';

export const useStyles = makeStyles({
  container: {
    border: `1px solid ${colors.neutral100}`,
    borderRadius: '8px !important',
    boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.04)',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 4,
    // minWidth: 680,
    // width: '100%',
    backgroundColor: 'white',
    maxHeight: 'calc(100vh - 200px)',
    overflowY: 'auto',
    overflowX: 'hidden',
    height: 'fit-content',
    flex: 2,
  },
  procedureHeader: {
    padding: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  procedureHeaderText: {
    fontWeight: 600,
    fontSize: 18,
    lineHeight: '24px',
    color: colors.neutral900,
  },
  procedureBody: {
    borderTop: `1px solid ${colors.neutral100}`,
    borderBottom: `1px solid ${colors.neutral100}`,
    padding: 24,
  },
  procedureUuid: {
    fontWeight: 700,
    fontSize: '22px',
    lineHeight: '28px',
    color: colors.neutral900,
    fontFamily: 'Manrope',
    letterSpacing: '-0.22px',
  },
  procedureServiceName: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    color: colors.neutral700,
    fontFamily: 'Manrope',
  },
  procedureCodes: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    color: colors.neutral500,
    fontFamily: 'Manrope',
  },
  procedureFooter: {
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
  },
  procedureFooterText: {
    textAlign: 'center',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.neutral900,
  },
  procedureFooterBtn: {
    textTransform: 'none !important',
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '20px',
    color: colors.primary500,
    padding: 0,
    maxHeight: '20px',
  },
});
